var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text SMS",
    clipPath: "url(#clip0_572_18844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "149.sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M24 12.4462C24 5.81875 18.6274 0.446167 12 0.446167C5.37258 0.446167 0 5.81875 0 12.4462C0 19.0736 5.37258 24.4462 12 24.4462C18.6274 24.4462 24 19.0736 24 12.4462Z",
    fill: "#0027D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M15.8184 7.27527H8.182C7.82034 7.27527 7.47349 7.41894 7.21776 7.67467C6.96203 7.9304 6.81836 8.27725 6.81836 8.6389V17.6116L9.50472 15.6807H15.8184C16.18 15.6807 16.5269 15.5371 16.7826 15.2813C17.0383 15.0256 17.182 14.6787 17.182 14.3171V8.64436C17.1827 8.46483 17.148 8.28692 17.0798 8.12084C17.0116 7.95477 16.9112 7.8038 16.7845 7.67659C16.6578 7.54939 16.5073 7.44846 16.3415 7.37959C16.1757 7.31072 15.9979 7.27527 15.8184 7.27527ZM9.61381 12.153C9.48598 12.153 9.36101 12.1151 9.25471 12.0441C9.14842 11.973 9.06557 11.8721 9.01665 11.754C8.96773 11.6359 8.95493 11.5059 8.97987 11.3805C9.00481 11.2552 9.06637 11.14 9.15677 11.0496C9.24716 10.9592 9.36233 10.8976 9.48771 10.8727C9.6131 10.8477 9.74306 10.8605 9.86117 10.9095C9.97927 10.9584 10.0802 11.0412 10.1512 11.1475C10.2223 11.2538 10.2602 11.3788 10.2602 11.5066C10.2602 11.6781 10.1921 11.8425 10.0709 11.9637C9.94965 12.0849 9.78524 12.153 9.61381 12.153ZM12.0002 12.153C11.8723 12.153 11.7474 12.1151 11.6411 12.0441C11.5348 11.973 11.4519 11.8721 11.403 11.754C11.3541 11.6359 11.3413 11.5059 11.3662 11.3805C11.3912 11.2552 11.4527 11.14 11.5431 11.0496C11.6335 10.9592 11.7487 10.8976 11.8741 10.8727C11.9995 10.8477 12.1294 10.8605 12.2475 10.9095C12.3656 10.9584 12.4666 11.0412 12.5376 11.1475C12.6086 11.2538 12.6465 11.3788 12.6465 11.5066C12.6465 11.6781 12.5784 11.8425 12.4572 11.9637C12.336 12.0849 12.1716 12.153 12.0002 12.153ZM14.3865 12.153C14.2587 12.153 14.1337 12.1151 14.0274 12.0441C13.9211 11.973 13.8383 11.8721 13.7894 11.754C13.7405 11.6359 13.7277 11.5059 13.7526 11.3805C13.7775 11.2552 13.8391 11.14 13.9295 11.0496C14.0199 10.9592 14.1351 10.8976 14.2604 10.8727C14.3858 10.8477 14.5158 10.8605 14.6339 10.9095C14.752 10.9584 14.853 11.0412 14.924 11.1475C14.995 11.2538 15.0329 11.3788 15.0329 11.5066C15.0329 11.6781 14.9648 11.8425 14.8436 11.9637C14.7224 12.0849 14.558 12.153 14.3865 12.153Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_18844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.446167)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/SMS.ef57a48eb7cfeba48bdaf8e57ad241e1.svg";
export { ForwardRef as ReactComponent };